import { useOptionalCurrentUserDataQuery, UsersListParams } from '@/api/user/user.api';
import CustomCheckbox from '@/components/@next/CustomCheckbox/CustomCheckbox';
import * as Dialog from '@radix-ui/react-dialog';
import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { TbAdjustmentsHorizontal } from 'react-icons/tb';
import styles from '../../../categories/components/FiltersDialog/FiltersDialog.module.scss';

export type UsersFilterDialogParams = Pick<UsersListParams, 'sameCity' | 'secureMembers'>;

const FiltersDialog = ({
  filters,
  onApplyClick,
}: {
  filters: UsersFilterDialogParams;
  onApplyClick: (values: UsersFilterDialogParams) => void;
}) => {
  const [values, setValues] = useState<UsersFilterDialogParams>({
    sameCity: false,
    secureMembers: false,
  });

  const currentUser = useOptionalCurrentUserDataQuery();
  const isSameCityAvailable = currentUser.data && currentUser.data.country && currentUser.data.city;

  return (
    <Dialog.Root onOpenChange={() => setValues(filters)}>
      <Dialog.Trigger asChild>
        <button className="btn-new btn-primary-outlinebtn-new btn-primary-outline px-4 py-3 border border-gray-d9 font-bold text-primary rounded-lg flex items-center">
          <TbAdjustmentsHorizontal className="mr-2" />
          Filters
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.DialogOverlay} />
        <Dialog.Content className={styles.DialogContent}>
          <div className="flex flex-row justify-between border-b border-gray-70 pb-4">
            <Dialog.Title className="text-secondary font-bold text-lg">Filter Items</Dialog.Title>
            <Dialog.Close asChild>
              <button className="text-secondary hover:text-danger" aria-label="Close">
                <FaTimes />
              </button>
            </Dialog.Close>
          </div>
          <div>
            {isSameCityAvailable && (
              <CustomCheckbox
                label="Same city"
                checked={filters.sameCity}
                onChange={(value) =>
                  setValues((prev) => ({
                    ...prev,
                    sameCity: value,
                  }))
                }
              />
            )}

            <CustomCheckbox
              label="Secure members ONLY"
              checked={filters.secureMembers}
              onChange={(value) =>
                setValues((prev) => ({
                  ...prev,
                  secureMembers: value,
                }))
              }
            />
          </div>
          <div className="flex justify-end mt-10">
            <Dialog.Close asChild>
              <button className="btn-new btn-primary" onClick={() => onApplyClick(values)}>
                Apply Filters
              </button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default FiltersDialog;
